module.exports = __webpack_public_path__ + "media/images/guidelineReport-4166e0ba8daf263a7e74560590f64de3132bd6d2b7f408e3c53ef41807b784a1.svg";